"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeRow = exports.getHeaderRenameFunction = void 0;
const helpers_1 = require("./helpers");
const getHeaderRenameFunction = (sanitizeFieldNames) => {
    return (rawHeader) => (0, helpers_1.getSanitizedFieldName)(rawHeader, sanitizeFieldNames);
};
exports.getHeaderRenameFunction = getHeaderRenameFunction;
const sanitizeRow = ({ csvRow, lineNumber, baseFieldConfigs, }) => {
    const sanitizedRowResult = (0, helpers_1.getSanitizedRowData)({
        row: csvRow,
        rowIndex: lineNumber,
        baseFieldConfigs,
        preSanitized: false,
    });
    if (sanitizedRowResult.isValid) {
        return { success: true, value: sanitizedRowResult.data };
    }
    return { success: false, error: sanitizedRowResult.error };
};
exports.sanitizeRow = sanitizeRow;
//# sourceMappingURL=stream.js.map